export const FilterOperators = {
    equals: '=',
    contains: 'IN',
    notEqual: '<>',
    greaterThan: '>',
    lessThan: '<',
    greaterThanOrEqual: '>=',
    lessThanOrEqual: '<=',
    between: 'BETWEEN'
  };